module.exports = __webpack_public_path__ + "img/102021.137c9f32.png";